import {createStore} from "effector";

export const $searchByIdData = createStore([])
$searchByIdData.watch(state => console.log('$searchByIdData', state))

export const $searchByIdSearchValue = createStore('')
